<div class="messagebox-content">
  <fa-icon *ngIf="data.icon !== MessageBoxIcon.None" [icon]="faIcon" [ngClass]="iconClass" class="messagebox-icon"></fa-icon>
  <p class="messagebox-text" [innerHTML]="modalRef.modalConfig.stringsAreTranslationKeys ? (data.text | translate) : data.text"></p>
</div>
